import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { NAV } from "@/constants/testIds";
import BrandLogo from "@/components/BrandLogo";

export default function TopBar({ variant = "public" }) {
  const { user, logout } = useAuth();
  const isDashboard = variant === "dashboard";
  const [brand, setBrand] = useState({ title: "Expansión Rubí", subtitle: "Proyecto Diamante" });
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (isDashboard) return;
    (async () => {
      try {
        const r = await api.get("/public/content");
        if (r.data?.brand) setBrand((b) => ({ ...b, ...r.data.brand }));
      } catch (_e) { /* noop */ }
    })();
  }, [isDashboard]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const wrapCls = `sticky top-0 z-40 transition-all duration-300 ${
    scrolled
      ? "backdrop-blur-2xl bg-[#FAFAFA]/85 border-b border-black/6"
      : "backdrop-blur-md bg-transparent border-b border-transparent"
  }`;

  return (
    <header className={wrapCls}>
      <div className="max-w-[1300px] mx-auto flex items-center justify-between px-6 lg:px-10 py-3.5">
        <Link to="/" data-testid={NAV.home} className="group">
          <BrandLogo size={36} showText brand={brand.title} sub={brand.subtitle} onLight />
        </Link>

        <nav className="flex items-center gap-2 sm:gap-6 text-sm">
          {!isDashboard && (
            <>
              <a href="#quienes-somos" className="hidden md:inline text-[13px] text-[#3F3F46] hover:text-[#0A0A0A] transition-colors" data-testid="nav-conocenos">Conócenos</a>
              <a href="#ubicaciones" className="hidden md:inline text-[13px] text-[#3F3F46] hover:text-[#0A0A0A] transition-colors">Ubicaciones</a>
              <a href="#proyectos" className="hidden md:inline text-[13px] text-[#3F3F46] hover:text-[#0A0A0A] transition-colors">Proyectos</a>
              <a href="#como-funciona" className="hidden md:inline text-[13px] text-[#3F3F46] hover:text-[#0A0A0A] transition-colors">Cómo funciona</a>
              <a href="#preguntas" className="hidden md:inline text-[13px] text-[#3F3F46] hover:text-[#0A0A0A] transition-colors">Preguntas</a>
              <Link to="/calificacion" data-testid={NAV.formulario} className="btn-primary !py-2 !px-4 !text-xs">
                Evaluar mi participación
              </Link>
            </>
          )}
          {isDashboard && (
            <>
              <Link to="/dashboard" className="text-[#3F3F46] hover:text-[#0A0A0A] transition-colors" data-testid={NAV.dashboard}>
                Pipeline
              </Link>
              <span className="hidden sm:inline text-xs text-[#8F8578]">|</span>
              <div className="hidden sm:flex items-center gap-3">
                <div className="text-right leading-tight">
                  <div className="text-xs text-[#3F3F46]">{user?.name}</div>
                  <div className="text-[10px] uppercase tracking-widest text-[#FFBF57]">{user?.role}</div>
                </div>
              </div>
              <button onClick={logout} data-testid={NAV.logout} className="btn-outline !py-2 !px-4 !text-xs">
                Salir
              </button>
            </>
          )}
          {!isDashboard && !user && (
            <Link to="/login" data-testid={NAV.login} className="hidden sm:inline transition-colors text-[10px] uppercase tracking-[0.22em] font-mono text-[#8F8578] hover:text-[#0A0A0A]">
              Equipo
            </Link>
          )}
          {!isDashboard && user && (
            <Link to="/dashboard" className="hidden sm:inline transition-colors text-[10px] uppercase tracking-[0.22em] font-mono text-[#8F8578] hover:text-[#0A0A0A]">
              CRM
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
